/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ALL_COMPRESSED_GAS_CYLINDERS_ARE_SECURE_FROM_ACCIDENTAL_TIPPING',
              'ALL_COMPRESSED_GAS_CYLINDERS_HAVE_CLOSED_VALVES_WHEN_NOT_IN_USE',
              'COMPRESSED_GAS_CYLINDERS_ARE_TRANSPORTED_SAFELY',
              'COMPRESSED_GAS_CYLINDERS_ARE_STORED_AWAY_FROM_HEAT_AND_OTHER_FI',
              'COMPRESSED_GAS_CYLINDERS_ARE_ONLY_USED_BY_QUALIFIED_WORKERS',
              'COMPRESSED_GAS_CYLINDERS_ARE_LABELED_AND_SEGREGATED',
              'COMPRESSED_GAS_CYLINDERS_ARE_STORED_IN_AN_ENCLOSED_CAGE',
              'STATIONARY_COMPRESSED_GAS_CYLINDERS_ARE_CONNECTED_WITH_FIXED_PI',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_8: valueSchema,
  },
}
